import React, { useState, useEffect, Component } from "react";
import { Passers } from "prop-passer";
import {
    FacebookShareButton,
    TwitterShareButton,
    LinkedinShareButton,
    WhatsappShareButton,
    PinterestShareButton,
    VKShareButton,

    FacebookIcon,
    TwitterIcon,
    LinkedinIcon,
    WhatsappIcon,
    PinterestIcon,
    VKIcon,
} from "react-share";
import { getPost } from "../actions/productActions";
import { addWishlist } from "../actions/wishlistActions";
import { addCart } from "../actions/cartAction";
import { connect } from "react-redux";
import SubShareCSS from "./CSS/index";

class SubShare extends Component {

    render() {

        const {
            url = String(window.location),
            title = this.props.products.post.pname,
            shareImage = this.props.products.post.image1,
            size = "2.5rem",
        } = this.props;

        const ShareList = Passers({
            url,
            className: "network__share-button",
        })({
            className: "network cursor-pointer hover transition--default",
            title: `Share ${String(window.location)}`,
        })("row");

        return (
            <SubShareCSS >
                <ShareList>
                    <FacebookShareButton
                        quote={title}
                    >
                        <FacebookIcon
                            size={size}
                        />
                    </FacebookShareButton>

                    <TwitterShareButton
                        title={title}
                    >
                        <TwitterIcon
                            size={size}
                        />
                    </TwitterShareButton>

                    <WhatsappShareButton
                        title={"\n" + "*" + title + "*" + "\n\n" + "*Price : " + this.props.products.post.price + "*" + "\n\n" + "```Description - " + "\n\n" + this.props.products.post.text + "```"}
                        separator={"_" + "Product by :: " + this.props.website.website.header + "_" + "\n\n" + "```Contact Us - " + "91" + this.props.website.website.phone1 + "```" + "\n\n" + "_powered by -_" + " " + "*KAAL*" + "\n\n"}
                        url={"```" + url + "```"}
                    >
                        <WhatsappIcon size={size} />
                    </WhatsappShareButton>

                    <LinkedinShareButton
                        title={title}
                        windowWidth={750}
                        windowHeight={600}
                    >
                        <LinkedinIcon
                            size={size}

                        />
                    </LinkedinShareButton>

                    <PinterestShareButton
                        url={String(window.location)}
                        media={`${shareImage}`}
                        windowWidth={1000}
                        windowHeight={730}
                    >
                        <PinterestIcon size={size} />
                    </PinterestShareButton>
                </ShareList>
            </SubShareCSS>
        );
    }
}
const mapStateToProps = (state) => ({
    main: state.main,
    products: state.products,
    // post: state.products.post,
    pname: state.products.post.pname,
    cart: state.cart,
    auth: state.auth,
    website: state.website,
});
export default connect(mapStateToProps, {
    getPost,
    addCart,
    addWishlist,
})(SubShare);

